"use client"

import styled from "styled-components"

export const AppContainer = styled.div`
  display: flex;
  -webkit-overflow-scrolling: touch;
`

export const Content = styled.div`
  display: flex;
  flex: 1;
`
